import React from 'react';
import ThreeInOneReports from 'components/business/ThreeInOneReports';

export const ReportsCtx = React.createContext({});

function ThreeInOnePageProvider(props) {
  const ctx = {
  };
  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function ThreeInOnePage() {
  return (
    <ThreeInOnePageProvider>
      <ThreeInOneReports />
    </ThreeInOnePageProvider>
  );
}

export default ThreeInOnePage;
